import { render, staticRenderFns } from "./DialogMail.vue?vue&type=template&id=7b4e3610&"
import script from "./DialogMail.vue?vue&type=script&lang=ts&"
export * from "./DialogMail.vue?vue&type=script&lang=ts&"
import style0 from "./DialogMail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports